import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {ModalDirective} from "ng2-bootstrap";

@Component({
    selector: 'confirm-dialog',
    templateUrl: 'confirm.template.html',
    exportAs: 'confirmDialog'
})
export class ConfirmComponent {

    public title: string;
    public bodyLabel: any = '';

    @ViewChild('modalConfirm') public modalConfirm: ModalDirective;

    @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();


    public show(title: string){
        this.title = title;
        this.modalConfirm.show();
    }

    public hide() {
        this.modalConfirm.hide();
    }

    public ok() {
        this.modalConfirm.hide();
        this.onSuccess.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/confirm/confirm.component.ts